import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/nextjs/src/components/AuthorImage.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
